import Items from './items'
import Create from './create'
import Next from './next'
import Explorer from './explorer'
import Loading from './loading'
import Empty from '../../../empty/module/simple'
import Pagination from './pagination'

export default {
    Items,
    Create,
    Next,
    Empty,
    Explorer,
    Loading,
    Pagination
}